import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/material',
  title: window.language['menu.material'],
  component: dynamicWrapper(app, [import('../../HomePage/model'), import('./model'), import('../Folder/model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Material/Material/index.js